export default __webpack_public_path__ + "static/media/icon_pinterest.4966423f.svg";